import { QrCode, Search, Store, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { QrScanner } from "@/components/verify/QrScanner";

export function ReceiptLookupCard({ store, serial, setSerial, lookup, busy, logout, scanning, setScanning, hidden }) {
  return (
    <Card className={`p-5 bg-card border-border space-y-4 ${hidden ? "hidden" : ""}`}>
      <div className="flex items-center justify-between gap-3 rounded-lg bg-secondary/40 px-3 py-2">
        <div className="flex items-center gap-2 text-sm">
          <Store className="h-4 w-4 text-primary" />
          <span className="text-muted-foreground">Sede:</span>
          <span className="font-semibold" data-testid="verify-store-name">{store.name}</span>
        </div>
        <Button data-testid="verify-logout-button" variant="ghost" size="sm" onClick={logout} className="gap-1.5">
          <LogOut className="h-3.5 w-3.5" /> Esci
        </Button>
      </div>
      <div className="space-y-1.5">
        <Label>Seriale ricevuta</Label>
        <div className="flex gap-2">
          <Input data-testid="verify-serial-input" value={serial} onChange={(e) => setSerial(e.target.value)} onKeyDown={(e) => e.key === "Enter" && lookup()} placeholder="WIN-20260927-XXXXXX" className="font-mono-code uppercase" />
          <Button data-testid="verify-lookup-button" onClick={() => lookup()} disabled={busy} className="gap-2 shrink-0">
            <Search className="h-4 w-4" /> Verifica
          </Button>
        </div>
      </div>
      <Button data-testid="verify-scan-button" variant="secondary" onClick={() => setScanning((s) => !s)} className="w-full gap-2">
        <QrCode className="h-4 w-4" /> {scanning ? "Chiudi fotocamera" : "Scansiona QR ricevuta"}
      </Button>
      <QrScanner active={scanning} elementId="verify-qr-reader" onDecoded={lookup} onClose={() => setScanning(false)} />
    </Card>
  );
}
